import useDashboards from '@/pages/Dashboards/hooks/useDashboards.ts'
import { IDashboard } from '@/pages/Dashboards/dashboards.types.ts'
import { useMemo } from 'react'

const useDashboard = (id: IDashboard['id']) => {
  const items = useDashboards().dashboards

  return useMemo(() => {
    return items.find((d) => d.id === id)
  }, [id, items])
}

export default useDashboard
